import React, { useEffect, useState } from "react";
import UserDashboard from "./UserDashboard";

const UserDashboardWrapper = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) setUser(storedUser);
  }, []);

  if (!user)
    return (
      <p style={{ textAlign: "center", marginTop: "2rem" }}>
        Please login to view your dashboard.
      </p>
    );

  return <UserDashboard user={user} />;
};

export default UserDashboardWrapper;
